import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Form, Loading } from "components";

const CSVReader = ({ onFileLoaded }) => {
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (event) => {
        const csvData = event.target.result;

        const parsedData = csvData
          .split(/\r?\n/)
          .filter((line) => line)
          .map((line) => line.split(/[;,]/))
          .map(([cpf, number_of_points]) => ({
            cpf: cpf.replace(/\D/g, "").trim(),
            number_of_points: Number(number_of_points),
          }));

        onFileLoaded(parsedData);
      };

      reader.readAsText(file);
    }
  };

  return <input type="file" accept=".csv" onChange={handleFileChange} />;
};

const CPFListForm = ({
  data: initialData,
  onChange,
  saving,
  onSubmit,
  errors,
}) => {
  const [data, setData] = useState(initialData);

  useEffect(() => {
    onChange(data);
  }, [data, onChange]);

  useEffect(() => {
    setData(initialData);
  }, [initialData]);

  const handleChangeInput = (e) => {
    const { value, name } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleLoadCSV = (csvData) => {
    csvData.shift();
    setData({
      ...data,
      inhabitants: csvData,
    });
  };

  return (
    <Form className="page-form">
      <h3 className="form-title">Atribuir Pontos para uma Lista de CPFs</h3>

      <Form.Field>
        <Form.Label>Habitantes</Form.Label>
        <div className="csv-file-cpf">
          <CSVReader onFileLoaded={handleLoadCSV} />
          <a href="/assets/downloads/bulk-import-points.csv">
            Baixar modelo do arquivo de importação.
          </a>
          <small>
            Obs.: Necessário o envio do CPF considerando 11 dígitos: Exemplo:
            00999999999 ou 009.999.999-99
          </small>
        </div>
      </Form.Field>

      <Form.Field>
        <Form.Label>Motivo da pontuação</Form.Label>
        <Form.Input
          name="reason"
          placeholder="Qual o motivo da soma/subtração de pontos para este habitante?"
          value={data.reason}
          onChange={handleChangeInput}
          errors={errors.reason}
        />
      </Form.Field>

      <div className="buttons">
        <Link to="/points/cpf-list" className="button-cancel">
          Cancelar
        </Link>

        <Form.Button
          className="button-save"
          onClick={onSubmit}
          disabled={saving}
        >
          {saving ? (
            <Loading type="btn" size="small" text="Salvando..." />
          ) : (
            "Salvar"
          )}
        </Form.Button>
      </div>
    </Form>
  );
};

export default CPFListForm;
